export function sumLength(list, key) {
  return (list || []).reduce((acc, m) => {
    const v = m?.[key];
    return acc + (Array.isArray(v) ? v.length : Number(v) || 0);
  }, 0);
}

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const then = new Date(dateStr).getTime();
  if (Number.isNaN(then)) return "";
  const diffMs = Date.now() - then;
  const min = Math.round(diffMs / 60000);
  if (min < 1) return "agora mesmo";
  if (min < 60) return `há ${min} min`;
  const hours = Math.round(min / 60);
  if (hours < 24) return `há ${hours}h`;
  const days = Math.round(hours / 24);
  if (days === 1) return "ontem";
  if (days < 30) return `há ${days} dias`;
  return new Date(dateStr).toLocaleDateString("pt-BR");
}

export function getModulos() {
  try {
    const raw = localStorage.getItem("modulos") || "{}";
    return typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch {
    return {};
  }
}

export function getPerfil() {
  try {
    return JSON.parse(localStorage.getItem("perfil")) || {};
  } catch {
    return {};
  }
}

// Regras de acesso replicando a lógica dos cards de produto.
export function buildAccess(modulos) {
  const verifyModules = window?.config?.REACT_APP_VERIFY_MODULES;
  const suspended = modulos?.status === 2;
  const has = (plan) =>
    verifyModules !== "true" || (Boolean(plan) && !suspended);
  return {
    suspended,
    easyMaps: has(modulos?.planoCombo || modulos?.planoEasyMaps),
    easyReport: has(modulos?.planoEasyReport),
    easyLog: has(modulos?.planoEasyLogs),
    easyBI: has(modulos?.planoEasyBI),
    easyMon: has(modulos?.planoCombo || modulos?.planoEasyMon),
    easyFlow: has(modulos?.planoCombo || modulos?.planoEasyFlow),
  };
}
